export const FETCH_LANDINGS = {
  init: 'landingsInfo/FETCH_LANDINGS/init',
  request: 'landingsInfo/FETCH_LANDINGS/request',
  success: 'landingsInfo/FETCH_LANDINGS/success',
  failure: 'landingsInfo/FETCH_LANDINGS/failure',
  cancel: 'landingsInfo/FETCH_LANDINGS/cancel',
} as const;

export const LANDINGS_RESET = 'landingsInfo/RESET' as const;

export const LANDINGS_STORE_NAME = 'landings' as const;
